<!-- eslint-disable no-unused-vars -->
<template>
  <b-card>
    <b-card-body class="m-0, p-0">
      <div class="custom-search d-flex justify-content-end">
        <b-form-group>
          <div class="d-flex align-items-center">
            <label style="width: 100px" class="mr-1">Tìm kiếm</label>
            <b-form-input
              v-model="searchRef.value"
              placeholder="Tìm kiếm"
              type="text"
              class="d-inline-block"
            />
          </div>
        </b-form-group>

        <b-form-group class="ml-1" :disabled="isLoaded">
          <b-button
            v-ripple.400="'rgba(113, 102, 240, 0.15)'"
            variant="primary"
            @click="$emit('show-edit', {})"
          >
            <feather-icon icon="PlusIcon" />
          </b-button>
        </b-form-group>
      </div>
    </b-card-body>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :rows="dataTable"
      :search-options="{
        enabled: false,
        externalQuery: searchRef.value,
      }"
      :pagination-options="{
        enabled: true,
        perPage: pageLength,
      }"
      styleClass="vgt-table"
    >
      <template slot="table-row" slot-scope="props">
        <!-- Column: Code -->
        <span v-if="props.column.field === 'code'" class="text-nowrap">
          <span class="text-nowrap">
            {{ props.row.code }}
          </span>
        </span>

        <!-- Column: Action -->
        <span v-else-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              variant="link"
              toggle-class="text-decoration-none btn-padding-table"
              no-caret
            >
              <template v-slot:button-content>
                <feather-icon
                  icon="MoreVerticalIcon"
                  size="16"
                  class="text-body align-middle"
                />
              </template>

              <b-dropdown-item @click="showEdit(props.row)">
                <feather-icon icon="Edit2Icon" class="mr-50" />
                <span>Sửa</span>
              </b-dropdown-item>
              <b-dropdown-item @click="showConfirmDeleteModule(props.row)">
                <feather-icon icon="TrashIcon" class="mr-50" />
                <span>Xóa</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template slot="pagination-bottom" slot-scope="props">
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap"> Hiển thị 1 đến </span>
            <b-form-select
              v-model="pageLength"
              :options="['10', '20', '50', '100', '500']"
              class="mx-1"
              @input="
                (value) => props.perPageChanged({ currentPerPage: value })
              "
            />
            <span class="text-nowrap"> của {{ props.total }} dòng </span>
          </div>
          <div>
            <b-pagination
              :value="1"
              :total-rows="props.total"
              :per-page="pageLength"
              first-number
              last-number
              align="right"
              prev-class="prev-item"
              next-class="next-item"
              class="mt-1 mb-0"
              @input="(value) => props.pageChanged({ currentPage: value })"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
  </b-card>
</template>

<script>
import {
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BCard,
  BButton,
  BCardBody,
  BFormCheckbox,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { VueGoodTable } from "vue-good-table";
// eslint-disable-next-line no-unused-vars
import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store/index";
import { HinhThucChuyenCongTacDelete as DeleteData } from "@/services/api/HoSoCanBoCongChuc/DanhMuc/HinhThucChuyenCongTacService";

export default {
  directives: {
    Ripple,
  },
  components: {
    BCard,
    BCardBody,
    BButton,
    VueGoodTable,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BFormCheckbox,
  },
  props: {
    dataTable: {
      type: Array,
      required: true,
    },
    isLoaded: {
      type: Boolean,
      required: true,
    },
    searchRef: {
      type: Object,
      default: { value: "" },
    },
  },
  data() {
    return {
      isWait: false,
      pageLength: 10,
      dir: false,
      columns: [
        {
          label: "Mã",
          field: "code",
        },
        {
          label: "Tên",
          field: "name",
        },
        {
          label: "Mô tả",
          field: "description",
        },
        {
          label: "Sort",
          field: "sort",
        },
        {
          label: "#",
          field: "action",
          tdClass: "text-center",
          thClass: "text-center",
        },
      ],
      searchTerm: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    showEdit(data) {
      this.$emit("show-edit", JSON.parse(JSON.stringify(data)));
    },

    showConfirmDeleteModule(data) {
      if (this.isWait) {
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Notification",
            icon: "CoffeeIcon",
            variant: "info",
            text: "In Progress",
          },
        });
      } else {
        this.$bvModal
          .msgBoxConfirm("Xác nhận xoá", {
            okTitle: "Đồng ý",
            cancelTitle: "Hủy",
            cancelVariant: "outline-secondary",
          })
          .then((value) => {
            if (value) {
              this.isWait = true;
              DeleteData({
                id: data.id,
              }).then((res) => {
                this.isWait = false;
                if (res.isError) {
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thất bại",
                      icon: "AlertTriangleIcon",
                      variant: "error",
                      text: res.message,
                    },
                  });
                } else {
                  this.$emit("remove-item", data);
                  this.$toast({
                    component: ToastificationContent,
                    position: "top-right",
                    props: {
                      title: "Thành công",
                      icon: "CheckIcon",
                      variant: "success",
                      text: res.message,
                    },
                  });
                }
              });
            }
          });
      }
    },
  },
};
</script>
